const attachment_utility = require('civicsUtils/attachment_utility');
define(function(require) {
  	var IpsModel = require('civicsBase/ipsModel');
  	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/cdr/hearings/{0}',
		parse:function(response){
			var data = response.data
			// data.hearingAttachments = attachmentConverter.convertAttachments(data.hearingAttachments ? data.hearingAttachments : data.attachments)
			data.hearingAttachments = data.hearingAttachments || data.attachments
			attachment_utility.parseVirusScanStatus(data.hearingAttachments);
			return data;
		}
	});
});
